module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAEHRSTlMAQLvjw1+H/6cEj6tPCAxvIfySsQAAAMVJREFUeAFioB8YBaNAyCSAJPVsgHbomAaBAAag6M0EYyxowAJwpAQGkHAS2E7DKWBFAhKQAMtPOv6GtX9u+ppGnKeh0BwRy+Bbxa/rVAMgNADhAQgNeOIZtBQFTcxB9ypxEtOvTIxi+zYTR3H/+E7EwZyfib15UCZ2AsjExQCZeCgAQgMQHoDQAIQFINYagNAAhAcgFEAbC9CnCNxKQAMNNNBAA6QB0gBpgDRAGiANkAZIA6QB0gBpgDRAGiANUBX4v677Ag5EwAoY4+JhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit-icon.png
// module id = 93
// module chunks = 0